export const SliderData = [
  {
    id: 1,
    image: 'img1.jpg',
    alt: 'Image One',
  },
  {
    id: 2,
    image: 'img2.jpg',
    alt: 'Image Two',
  },
  {
    id: 3,
    image: 'img3.jpg',
    alt: 'Image Three',
  },
  {
    id: 4,
    image: 'img4.jpg',
    alt: 'Image Four',
  },
  {
    id: 5,
    image: 'img5.jpg',
    alt: 'Image Five',
  },
]



// WEBPACK FOOTER //
// ./src/slider-assets/SliderData.js